<template>
  <div>
    <div class="list">
      <profile-item v-for="profile in list" :key="profile.id" :profile="profile" class="item" @remove="$emit('removeItem', profile)" />

      <observer class="list-observer" @fullyVisible="$emit('nextPage')" />
    </div>

    <c-loader v-if="loading" class="loader" :active="loading" label="Анкеты загружаются" :height="450" />
  </div>
</template>

<script>
import Observer from "@/components/IntersectionObserver";
import CLoader from "@/components/loader";
import ProfileItem from "./ProfileItem";

export default {
  components: { Observer, CLoader, ProfileItem },
  props: ["list", "loading"],
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.list {
  position: relative;
  border-left: 1px solid #dfe4ef;
  border-right: 1px solid #dfe4ef;

  .list-observer {
    position: absolute;
    bottom: -1px;
  }

  @include beforeBootstrapMd {
    margin-left: -20px;
    margin-right: -20px;
    border: none;
  }
}
</style>
